export default __webpack_public_path__ + "static/media/Helm of the Ragereaver.93eec29c.jpg";